import {Particle} from "./particle.js";
import {MASS, restDistanceX, restDistanceY} from "./contstants.js";

export function Cloth(w, h, foldsFactor, clothFunction, foldsCount) {
    var particles = [];
    var constraints = [];
    var u, v;
    var startingX = -125;
    var startingZ = -10;
    var zStepCoef = 10;
    var steps = [
        [10 - foldsFactor, zStepCoef],
        [10 - foldsFactor, 0],
        [5 - foldsFactor, -zStepCoef],
        [10 - foldsFactor, 0]
    ]; //[[<x step>, <z step>], [<x step>, <z step>], ...]

    if (foldsCount < 4) {
        steps = steps.reduce(function (res, current, index, array) {
            const dub = [];
            for (let i = 0; i < 4 - foldsCount; i++) {
                dub.push(current);
            }
            return res.concat(dub);
        }, []);
    }

    for (const step of steps) {
        if (foldsCount == 0) {
            step[1] = 0;
        }
    }
    // console.log(steps);
    var stepIndex = 0;
    var pp;
    w = w || 10;
    h = h || 10;
    this.w = w;
    this.h = h;

    function index(u, v) {
        return u + v * (w + 1);
    }

    // Create particles
    for (v = 0; v <= h; v++) {
        for (u = 0; u <= w; u++) {
            particles.push(
                new Particle(u / w, -v / h, 0, MASS, clothFunction)
            );
        }
    }

    if (foldsCount > 0) {
        for (var p of particles) {
            if (particles.indexOf(p) <= w) {
                if (!pp) {
                    p.original.setZ(startingZ);
                    p.position.setZ(startingZ);
                    p.original.setX(startingX);
                    p.position.setX(startingX);
                } else {
                    p.original.setZ(pp.original.z + steps[stepIndex][1]);
                    p.position.setZ(pp.position.z + steps[stepIndex][1]);
                    p.original.setX(pp.original.x + steps[stepIndex][0]);
                    p.position.setX(pp.position.x + steps[stepIndex][0]);
                    stepIndex++;
                    if (stepIndex >= steps.length) {
                        stepIndex = 0;
                    }
                }
                pp = p;
            }
        }
    }

    this.realW = Math.abs(particles[0].position.x - particles[w].position.x)

    // Structural
    for (v = 0; v < h; v++) {
        for (u = 0; u < w; u++) {
            constraints.push([
                particles[index(u, v)],
                particles[index(u, v + 1)],
                restDistanceY
            ]);
            constraints.push([
                particles[index(u, v)],
                particles[index(u + 1, v)],
                restDistanceX
            ]);
        }
    }

    for (u = w, v = 0; v < h; v++) {
        constraints.push([
            particles[index(u, v)],
            particles[index(u, v + 1)],
            restDistanceY

        ]);
    }

    for (v = h, u = 0; u < w; u++) {
        constraints.push([
            particles[index(u, v)],
            particles[index(u + 1, v)],
            restDistanceX
        ]);
    }

    this.particles = particles;
    this.constraints = constraints;
    this.index = index;

}
